<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 44.0037V24.0037M24 24.0037L6.58 14.0037M24 24.0037L41.42 14.0037M15 8.54371L33 18.8437M22 43.4637C22.6081 43.8148 23.2979 43.9996 24 43.9996C24.7021 43.9996 25.3919 43.8148 26 43.4637L40 35.4637C40.6075 35.113 41.112 34.6087 41.4631 34.0014C41.8141 33.3941 41.9993 32.7052 42 32.0037V16.0037C41.9993 15.3023 41.8141 14.6133 41.4631 14.006C41.112 13.3987 40.6075 12.8944 40 12.5437L26 4.54371C25.3919 4.19264 24.7021 4.00781 24 4.00781C23.2979 4.00781 22.6081 4.19264 22 4.54371L8 12.5437C7.39253 12.8944 6.88796 13.3987 6.53692 14.006C6.18589 14.6133 6.00072 15.3023 6 16.0037V32.0037C6.00072 32.7052 6.18589 33.3941 6.53692 34.0014C6.88796 34.6087 7.39253 35.113 8 35.4637L22 43.4637Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'PackIcon',
    props: {
        size: { type: [Number, String], default: 24 },
        color: { type: String, default: 'currentColor' },
    },
}
</script>
